export enum SuperappProvider {
  KASPI = 'kaspi',
}

export interface SuperappProviderRouter {
  handleAction: (action: string, payload: RouterActionPayload) => Promise<void>
}

export type RouterActionPayload = Record<string, string>
